import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Upgrade from "../../ui/Main/UI_Upgrade";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import { UI_MainMediator } from "./UI_MainMediator";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
export class UI_SkillMediator extends BaseUIMediator {
    constructor() {
        super(...arguments);
        this.skillList = [
            2, 3
        ];
    }
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_SkillMediator();
            this._instance._classDefine = UI_Upgrade;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        this.ui.m_btn_close.onClick(this, this.OnClose);
        let list = this.ui.m_view.m_list_view;
        list.itemRenderer = Laya.Handler.create(this, this.RenderItem, null, false);
        list.on(fairygui.Events.CLICK_ITEM, this, this.ClickItem);
        this.RefreshUI();
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.OpenGameBox();
        }
    }
    ClickItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            AudioManager.instance.PlayById(5);
            let index = item.data;
            let type = this.skillList[index];
            let config = GlobalUnit.dataManager.GetSkillConfig(type);
            if (config.cost_type == 2) {
                return;
            }
            if (config.cost_value == 1 || GameData.instance.coinCount < config.cost_value) {
                // if (!LTSDK.instance.configs.isADEnable) {
                //     return LTUI.Toast("金币不足");
                // }
                let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
                if (!res) {
                    return;
                }
                LTPlatform.instance.RecordEvent('game_ad', { level_id: GlobalUnit.game.level.config.id, id: 'skill_' + config.skill_type });
            }
            else {
                GameData.instance.coinCount -= config.cost_value;
            }
            GlobalUnit.dataManager.UpgradeSkill(type);
            this.RefreshUI();
            GameData.SaveToDisk();
            if (UI_MainMediator.instance.isShow) {
                UI_MainMediator.instance.RefreshUI();
            }
        });
    }
    RenderItem(index, item) {
        item.data = index;
        let type = this.skillList[index];
        let config = GlobalUnit.dataManager.GetSkillConfig(type);
        item.m_skill_type.selectedIndex = type;
        if (config.cost_type != 0) {
            item.m_cost_type.selectedIndex = config.cost_type;
        }
        else {
            if (GameData.instance.coinCount < config.cost_value) {
                item.m_cost_type.selectedIndex = 1;
                LTPlatform.instance.RecordEvent('game_ad_show', { level_id: GlobalUnit.game.level.config.id, id: 'skill_' + config.skill_type });
            }
            else {
                item.m_text_count.text = config.cost_value.toString();
            }
        }
        if (config.cost_type != 2) {
            item.m_text_level.text = config.skill_level + "j";
        }
    }
    RefreshUI() {
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
        let list = this.ui.m_view.m_list_view;
        list.numItems = this.skillList.length;
    }
    OnClose() {
        AudioManager.instance.PlayById(1);
        this.Hide();
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.HideGameBox();
        }
    }
    _OnHide() {
        this._openParam.run();
    }
}
